import { useEffect, type ReactNode } from 'react'

import classes from './ScrollableTable.module.scss'

export type ScrollableTableProps = {
    headRow: ReactNode
    children: ReactNode
    type: 'site' | 'channel'
}

export const ScrollableTable = ({
    headRow,
    children,
    type,
}: ScrollableTableProps) => {
    useEffect(() => {
        document.documentElement.style.setProperty(
            '--table-height-top-padding',
            type === 'site' ? '225px' : '285px'
        )
    }, [type])

    return (
        <div className={classes.tableWrapper}>
            <div className={classes.tableScroll}>
                <div className={classes.scrollContent}>
                    <table>
                        <thead>{headRow}</thead>
                        <tbody>{children}</tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}
